<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      style="height:50vh;overflow-y: scroll;"

      class="demo-ruleForm"
    >
      <el-form-item label="型号：" prop="model">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.model"
          placeholder="请输入型号"
          size="small"
          :maxlength="18"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="消费类型：" prop="type">
        <el-select
          style="width:95%"
          v-model="ruleForm.type"
          size="small"
          placeholder="请选择性别"
        >
          <el-option
            v-for="item in fireEquipmentType"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否完好：" prop="isIntact">
        <el-select
          style="width:95%"
          v-model="ruleForm.isIntact"
          size="small"
          placeholder="请选择是否完好"
        >
          <el-option
            v-for="item in fireEquipmentStatue"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="购买时间：">
        <el-date-picker
          style="width:95%"
          size="small"
          v-model="ruleForm.buyTime"
          :editable="false"
          type="date"
          :picker-options="pickerOptions"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="请选择购买时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="过期时间：">
        <el-date-picker
          style="width:95%"
          size="small"
          v-model="ruleForm.endTime"
          :editable="false"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="请选择过期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="位置：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.depositAddr"
          placeholder="请输入位置信息"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="设施图片:">
        <head-portrait-up-load
          :imageUrl="ruleForm.img"
          @imageChange="imageChange"
        ></head-portrait-up-load>
      </el-form-item>
      <el-form-item label="负责人姓名：" prop="name">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.name"
          placeholder="请输入负责人姓名"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人电话：" prop="phone">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.phone"
          placeholder="请输入负责人电话"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人职务：">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.job"
          placeholder="请输入负责人职务"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
     
    </el-form>
      <div style="text-align:right">
         <span slot="footer">
        <el-button type="primary" size="small" @click="saveSubmit('ruleForm')"
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          plain
          @click="cencelSubmit('ruleForm')"
          >取消</el-button
        >
      </span>
      </div> 
  </div>
</template>
<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "FireAddOrEdit",
  components: {
    HeadPortraitUpLoad
  },
  props: {
    defaultData: {
      type: Object,
      default: {
        return: {}
      }
    },
    showBox: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  computed: {
    fireEquipmentType() {
      return this.$store.state.select.fireEquipmentType; //消费类型
    },
    fireEquipmentStatue() {
      return this.$store.state.select.fireEquipmentStatue; //是否完好
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      ruleForm: this.defaultData,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      rules: {
        model: [{ required: true, message: " ", trigger: "blur" }],
        type: [{ required: true, message: " ", trigger: "change" }],
        name: [{ required: true, message: " ", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        isIntact: [{ required: true, message: " ", trigger: "change" }],
      }
    };
  },
  methods: {
    selectedAddDataDate() {
      this.ruleForm.age = this.$Common.calculationAges(this.ruleForm.birthday);
    },
    imageChange(src) {
      this.ruleForm.img = src || "";
    },
    //   提交
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    //   取消
    cencelSubmit(formName) {
      this.$refs[formName].resetFields();
      this.$emit("cencelSubmit");
    }
  },
  watch: {
    showBox: function(val) {
      this.$refs.ruleForm.resetFields();
      if (val) {
        this.ruleForm = Object.assign({}, this.defaultData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
